<template>
	<div
		:class="{
			[$style.footerDark]: true,
			[$style.footerFullWidth]: settings.isContentNoMaxWidth,
		}"
	>
		<div class="bg-black py-4">
			<div :class="$style.container">
				<div class="d-sm-flex align-items-sm-center">
					<div :class="$style.logo" class="clearfix mb-3 mr-sm-auto">
						<img
							src="resources/images/social.logo-sm.png"
							alt="Air UI"
							class="height-50"
						/>
						<div :class="$style.logoName">Socialytics</div>
						<div :class="$style.logoDescr">Control Panel</div>
					</div>
					<div class="d-flex flex-column flex-sm-row">
						<a class="mb-1 mb-sm-0 px-sm-3" target="blank" href="https://mercuriopi.com/">by Mercurio - Data Science &copy; 2021</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	computed: mapState(['settings']),
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
